import React from 'react';
export const lazyWithRetry = (componentImport) =>
    React.lazy(async () => {
        try {
            return await componentImport();
        } catch (error) {
            const isChunkError =
                error.name === 'ChunkLoadError' ||
                error.message?.includes('Loading chunk') ||
                error.message?.includes('missing');
            const hasReloaded = window.sessionStorage.getItem('retry-chunk-load-refresh');

            if (isChunkError && !hasReloaded) {
                window.sessionStorage.setItem('retry-chunk-load-refresh', 'true');
                window.location.reload();
                return new Promise(() => { });
            }
            throw error;
        }
    });
